import React from 'react'
import { Button, Container, Row } from 'reactstrap'
import { useState } from 'react';
import ValidationForm from '../../Forms/FormControls/FormValidation/ValidationForm'
import PlansAndPricingList from './Table/PlansAndPricing';
export default function PlansAndPricingContainer() {
    const [showForm, setShowForm] = useState(false);
    const [showTable, setShowTable] = useState(false)

    return (
        <Container fluid>
            <PlansAndPricingList />
        </Container>
    );
}
